import { CompanyDto } from './company-dto.model';


export class DepartmentDto implements IDepartmentDto {
    id!: number;
    company!: CompanyDto;
    departmentName!: string | undefined;
    isActive!: boolean;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.departmentName = _data["departmentName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["departmentName"] = this.departmentName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IDepartmentDto {
    id: number;
    company: CompanyDto;
    departmentName: string | undefined;
    isActive: boolean;
}

